import React from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/MasterData/ExpenseType/add'
import { v3_add_expenseType } from '../../../actions/v3/masterData'
import constant from '../../../constant'
import { toast } from 'react-toastify'
const Add = (props) => {

    const onSubmit = (model) => {
        v3_add_expenseType(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                props.history.push(constant.Authedcomponent.listExpenseTypeMasterData.url)
            }
            else {
                toast.error(res.error)

            }
        })
    }
    return (
        <React.Fragment>
            <Layout
                title={'Master Data'}
            >
                <Form
                    title={'Add Expense Type'}
                    onSubmit={onSubmit}
                    buttonName={'Create Expense Type'}
                />
            </Layout>
        </React.Fragment>
    )
}

export default Add